<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Project Group
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2">Username</span></b-input-group-prepend
            >
            <b-form-input v-model="filter.username"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="3">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-2 mr-2"
                >Project/Entity</span
              ></b-input-group-prepend
            >
            <b-form-select
              v-model="filter.pjxkey"
              :plain="true"
              :options="projects"
            ></b-form-select>
          </b-input-group>
        </b-col>
        <b-col md="5">
          <b-row>
            <b-button class="btn btn-success ml-3 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply Filter</b-button
            >
            <b-button class="btn btn-secondary mr-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter</b-button
            >
          </b-row>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        @row-clicked="rowClicked"
        :key="tblData.limit"
        show-empty
      >
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(seq)="data">
          <span>{{ data.index + 1 }}</span>
        </template>
        <template v-slot:cell(cust_po)="data">
          <span v-if="data.item.sales">{{ data.item.cust_po }}</span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total
            }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of
            {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-input-group>
            <b-input-group-prepend
              ><span class="pt-1 mr-2"
                >Limit per page</span
              ></b-input-group-prepend
            >
            <b-form-select
              :options="[10, 15, 20, 25, 30, 35, 40, 45, 50]"
              :plain="true"
              v-model="tblData.limit"
              size="sm"
              style="max-width: 80px"
            />
          </b-input-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal
        v-model="showDelConfirm"
        title="Delete Record?"
        :centered="true"
        @ok="deleteData"
      >
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Project Group - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend><label>User</label></b-input-group-prepend>
            <b-form-input
              readonly
              v-model="frmdata.username"
              :state="!$v.frmdata.username.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuUserShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Project/Entity</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="frmdata.pjxkey"
              :plain="true"
              :options="projectwithoutall"
              :state="!$v.frmdata.pjxkey.$error"

            ></b-form-select>
          </b-input-group>
          <div slot="footer" style="text-align: center">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form</b-button
            >
            <!-- <div
              v-if="$v.frmdata.sales.$error"
              style="color: red; margin-top: 10px"
            >
              External/Internal is required
            </div> -->
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="lkuUserShow"
      size="lg"
      :hide-footer="true"
      title="List of Users"
      :centered="true"
    >
      <lku-user @click="onSelectUser"></lku-user>
    </b-modal>
  </div>
</template>

<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 100px;
    }
  }
}
</style>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import lkuUser from "../lookup/lkuUser";

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import myNumber from "../../components/my-number";

toastr.init();

export default {
  components: { myNumber, lkuUser },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      username: { required },
      pjxkey: { required },
    },
  },
  data() {
    return {
      showDelConfirm: false,
      showList: true,
      showForm: false,
      lkuUserShow: false,
      frmdata: {},
      types: [],
      projects: [{ value: "", text: "--ALL--" }],
      studiolives: [],
      studiotapes: [],
      spotrates: [],
      tblData: {
        tablename: "projectgroupuser",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      filter: { username: "", pjxkey: "" },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "seq",
          label: "#",
          thStyle: "width:120px",
          sortable: true,
        },
        {
          key: "pjxname",
          label: "Project Name",
          sortable: true,
        },
        {
          key: "username",
          label: "username",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center",
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function () {
    const [a] = await Promise.all([
      crud.list({
        tablename: "vwproject",
        page: 1,
        limit: 1000,
        total: 0,
        sortBy: 'pjxname',
        sortDesc: false,
      }),
    ]);
    this.types = a.reduce((newArr, item) => {
      newArr.push({ value: item.pjxkey, text: item.pjxname });
      return newArr;
    }, []);
    this.projectwithoutall = this.types;
    this.projects = this.projects.concat(this.types);
  },
  methods: {
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.customQuery = "";
      let str = "";
      if (this.filter.username) {
        str = "username=%" + encodeURIComponent(this.filter.username) + "%";
      }
      if (this.filter.pjxkey) {
        str += str ? "&" : "";
        str = str + "pjxkey=" + encodeURIComponent(this.filter.pjxkey);
      }
      this.tblData.customQuery = str;

      const list = await crud.list(this.tblData);
      return list;
    },
    onSelectUser(_selected) {
      this.frmdata.username = _selected.username;
      this.frmdata.user_id = _selected.user_id;
      this.lkuUserShow = false;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.filter.pjxname = "";
      this.filter.pjxjobtype = "";
      this.refresh();
    },

    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.pjxkey;
      this.showForm = true;
      this.showList = false;
    },
    save: async function (callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.projectuserkey) {
            await crud.update({
              tablename: "projectgroupuser",
              key: this.frmdata.projectuserkey,
              data: {
                pjxkey: this.frmdata.pjxkey,
                pjxname: (this.projectwithoutall.find(x=>x.value==this.frmdata.pjxkey)).text,
                userid: this.frmdata.user_id,
                username: this.frmdata.username,
              },
            });
          } else {
            await crud.insert({
              tablename: "projectgroupuser",
              data: {
                pjxkey: this.frmdata.pjxkey,
                pjxname: (this.projectwithoutall.find(x=>x.value==this.frmdata.pjxkey)).text,
                userid: this.frmdata.user_id,
                username: this.frmdata.username,
              },
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await crud.remove({
        tablename: "projectgroupuser",
        key: this.model.projectuserkey,
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    onSelectLkuCustomer: async function (_selected) {
      this.frmdata.custinfo =
        _selected.CustName.trim() + " | " + _selected.CustCode.trim();
      this.frmdata.cust_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
